// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1ZCdm","header":"MergedInvoice_header__zo5g5"};